import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell" }, " Produto "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_9 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell",
  "data-title": "Produto"
}
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_12 = { class: "ui-actions" }
const _hoisted_13 = { class: "ui-action ui-move" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_produto = _resolveComponent("combo-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, { label: "Produto" }, {
              default: _withCtx(() => [
                _createVNode(_component_combo_produto, {
                  codigo: _ctx.state.codigoProduto,
                  "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoProduto) = $event)),
                  ignorarCodigos: [_ctx.props.codigoProduto]
                }, null, 8, ["codigo", "ignorarCodigos"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ui-button -primary ui-mh-32 ui-full",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarProdutoRelacionado()))
                }, _hoisted_6)
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.computedProdutosRelacionados.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhum produto foi adicionado ainda"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.computedProdutosRelacionados,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedProdutosRelacionados) = $event)),
                  "item-key": "index",
                  handle: ".ui-move"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-row ui-row"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_combo_produto, {
                          codigo: element.codigoProdutoRelacionado,
                          "onUpdate:codigo": ($event: any) => ((element.codigoProdutoRelacionado) = $event),
                          ignorarCodigos: [_ctx.props.codigoProduto],
                          disabled: true
                        }, null, 8, ["codigo", "onUpdate:codigo", "ignorarCodigos"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar os produtos" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_13, [
                                _createVNode(_component_icone, { nome: "ordenar-lista" })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.removerProdutoRelacionado(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_14)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}